import axios from "axios";
import vue from "@/main";
import EventBus from "@/tools/event-bus";
let codeList = [404, 401, 403];
let instance = axios.create({
  timeout: 200 * 1000, // request timeout
  headers: {
    "Content-Type": "application/json"
  },
  // baseURL: 'https://test.blackbe.api.nyan.xyz/'
  baseURL:"https://api.blackbe.work/"
});
instance.interceptors.request.use(
  config => {
    // 从vuex读取token
    config.headers.Authorization = vue.$store.state.token
    return config;
  },
  error => {
    Promise.error(error);
  }
);
instance.interceptors.response.use(
  response => {
    if (response.data.error === 4041) {
      vue.$router.push("/user/center");
    }
    if (response.data.success !== true && response.data.message) {
      EventBus.$emit("snackbar", {
        text: response.data.message,
        color: "pink"
      });
    }
    return response;
  },
  error => {
    if (
      error.code === "ECONNABORTED" &&
      error.message.indexOf("timeout") !== -1
    ) {
      error.response = {
        status: "ECONNABORTED",
        message: "请求超时",
        success: false
      };
    } else if (!codeList.includes(error.response.status)) {
      EventBus.$emit("snackbar", {
        text: error.response.data.message,
        color: "error"
      });
    } else if (error.response.status === 401) {
      vue.$router.push("/login");
    }else if (error.response.status === 403) {
      // 什么也不做
    } else {
      EventBus.$emit("snackbar", {
        text: error,
        color: "error"
      });
    }

    return error.response;
  }
);
export default instance;
